<template>
    <div class="realName" >

      <van-row class="van-cell">
            <van-col span="8">状态:</van-col>
            <van-col span="16">
                <span style="color: red">{{Authentication_Status_Desc_MAP[traderShow.acctDO.authenticationStatus]}}</span>
                <span style="color: red;padding-left:5px" v-if="!form.certSuccess"> {{form.certFailReason}}</span>
            </van-col>
      </van-row>

      <van-field
              v-model="form.cert_name"
              label="真实姓名"
              placeholder="请输入真实姓名"
      />
      <van-field
              v-model="form.cert_no"
              label="身份证号"
              placeholder="请输入身份证号"
      />

      <div style="padding: 10px 10%">
      <div style="height:180px;width:300px">
          <img :src="form.cert_y_base64Img" style="height:100%;width:100%"/>
      </div>


      <van-row class="van-cell" v-if="canSumbit">
              <van-col span="8">身份证正面:</van-col>
              <van-col span="16">
                <input type="file" name="fileY" @change="getFileY($event)" id="filey">
              </van-col>
      </van-row>


      <div style="height:180px;width:300px">
          <img :src="form.cert_n_base64Img" style="height:100%;width:100%" />
      </div>

      <van-row class="van-cell" v-if="canSumbit">
              <van-col span="8">身份证反面:</van-col>
              <van-col span="16">
                 <input type="file" name="fileN" @change="getFileN($event)"  id="filen">
              </van-col>
      </van-row>
      </div>

      <div class="buttom" v-if="canSumbit">
            <van-button size="large" round @click="submit($event)">提交认证</van-button>
      </div>

    </div>
</template>

<script>

  import userAPI from '@/api/user'
  import {lrz} from 'lrz'

  export default {
    name: "realName",
    data() {
      return {
        traderShow: {
          realNameAuthentication:{},
          acctDO:{
            authenticationStatus:0
          }
        },
        form:{
          certFailReason:'',
          certSuccess:false,
          cert_name:'',
          cert_no:'',
          cert_y_base64Img:null,
          cert_n_base64Img:null
        },
        fileY:null,
        textY:'',
        fileN:null,
        textN:'',
        submitLoading:false,
        showLoading:false,
        Authentication_Status_Desc_MAP:{'0':"待认证",'1':"认证成功",'2':"认证中"}
      }
    },
    computed: {
      canSumbit: function(){
        return this.traderShow&&this.traderShow.acctDO.authenticationStatus==0
      }
    },
    methods: {
      getFileY(event){
        this.fileY = event.target.files[0];
        this.textY = this.fileY.name
        window.lrz(this.fileY, {
          width: 1000 //设置压缩参数
        }).then((rst) => {
          /* 处理成功后执行 */
          this.fileY = rst.file
          var windowURL = window.URL || window.webkitURL;
          //createObjectURL创建一个指向该参数对象(图片)的URL
          this.form.cert_y_base64Img = windowURL.createObjectURL(this.fileY);
          console.log(this.form.cert_y_base64Img);
        }).catch(function (err) {
          console.log(err)
          this.$toast.fail("请上传正确的图片")
        })
      },
      getFileN(event){
        this.fileN = event.target.files[0];
        this.textN = this.fileN.name
        window.lrz(this.fileN, {
          width: 1000 //设置压缩参数
        }).then((rst) => {
          /* 处理成功后执行 */
          this.fileN = rst.file
          var windowURL = window.URL || window.webkitURL;
          //createObjectURL创建一个指向该参数对象(图片)的URL
          this.form.cert_n_base64Img = windowURL.createObjectURL(this.fileN);
          console.log(this.form.cert_n_base64Img);
        }).catch(function (err) {
          console.log(err)
          this.$toast.fail("请上传正确的图片")
        })
      },
      submit(event){
        if(this.form.cert_name==null||this.form.cert_name==''){
          this.$toast.fail("姓名不能为空")
          return
        }
        if(this.form.cert_no==null||this.form.cert_no==''||!this.$myUtil.isCertNo(this.form.cert_no)){
          this.$toast.fail("请输入正确的证件号")
          return
        }
        if (this.fileY != null) {
          var size = 0;
          size = this.fileY.size;//byte
          size = size / 1024;//kb
          size = (size / 1024).toFixed(3);//mb
          if (size > 1) {
            this.$toast.fail("身份证正面图片过大，图片大小不能超过1M")
            return
          }
        }else{

        }
        if (this.fileN != null) {
          var size = 0;
          size = this.fileN.size;//byte
          size = size / 1024;//kb
          size = (size / 1024).toFixed(3);//mb
          if (size > 1) {
            this.$toast.fail("身份证反面图片过大，图片大小不能超过1M")
            return
          }
         }else{

         }
        let formData = new FormData()
        formData.append('cert_y_base64ImgFile',this.fileY)
        formData.append('cert_n_base64ImgFile',this.fileN)
        Object.keys(this.form).forEach(key => {
          formData.append(key, this.form[key])
        })
        event.preventDefault();
        let config = {
          headers: {
          'Content-Type': 'multipart/form-data'
          }
        }
        this.$toast.loading({forbidClick:true})
        this.$http.post("/user/realNameAuth", formData, config)
        .then(result => {
          this.$toast.success(result.mng)
          this.queryShow()
        }).catch(() => {
          this.submitLoading=false
        })
      },
      queryShow() {
          this.$toast.loading({forbidClick:true})
          userAPI.show({showRealName:true}).then(result => {
              this.traderShow = result.data;
              this.form = this.traderShow.realNameAuthentication
              this.$toast.clear()
          })
      }
    },
    created() {
      this.queryShow()
    }
  }
</script>

<style lang="scss" scoped>
    .buttom {
        margin: 0.5rem 2rem;
        .van-button {
            background-color: #ee9900;
            color: #fff;
        }
    }
</style>
